import { editorialTopic } from './scenario-capability-editorial';
import { EditorialCapabilityImage, EditorialSources } from './ScenarioCapabilityReading';

/** Supporting methods are not new source-bound requirements. */
const references: Readonly<Record<string, { key: string; context: string }>> = {
  'HRF-HZ-02': { key: 'HR-GAS', context: '烟气环境检测与热成像不同；气体读数不能由热像推导。' },
  'HRF-HZ-05': { key: 'HR-MOVEMENT', context: '测量仅记录选定目标变化，不能替代结构安全鉴定。' },
  'HRF-HZ-06': {
    key: 'HR-MOVEMENT',
    context: '测量目标和观测条件须核对，不能据此判定构件稳定或落点。',
  },
};
export function ScenarioTechnicalReference({ issueCode }: { readonly issueCode: string }) {
  const ref = references[issueCode];
  const topic = ref ? editorialTopic(ref.key) : undefined;
  if (!ref || !topic) return null;
  return (
    <section className="scc-read-section" data-research-method>
      <h2>相关技术原理（研究参考）</h2>
      <p className="scc-section-lead">{ref.context} 以下为公开技术解释，未新增正式能力绑定。</p>
      <article className="scc-method-card">
        <EditorialCapabilityImage path={topic.image} title={topic.title} />
        <div>
          <h3>{topic.title}</h3>
          <p>可产生：{topic.outputs}</p>
          <p>实现方式：{topic.method}</p>
          <p>限制：{topic.limits}</p>
          <EditorialSources topic={topic} />
        </div>
      </article>
    </section>
  );
}
